import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useAuthorization } from '../../contexts/AuthorizationContext';
import { FaBars, FaTimes, FaClipboardCheck } from 'react-icons/fa';
import './Navbar.css';

function Navbar() {
  const { currentUser, logout } = useAuth();
  const { hasPermission } = useAuthorization();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login', { replace: true });
      setIsOpen(false);
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  const handleMenuClick = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = (path) => {
    setIsOpen(false);
    navigate(path);
  };

  return (
    <>
      <header className="header">
        <nav className="navbar">
          <div className="logo">
            <Link to="/">MOMOH</Link>
          </div>
          
          <div className="nav-controls">
            {currentUser && (
              <button 
                className="menu-button"
                onClick={handleMenuClick}
                aria-label="Toggle menu"
              >
                {isOpen ? <FaTimes /> : <FaBars />}
              </button>
            )}
            
            {!currentUser && (
              <div className="nav-right">
                <Link to="/login" className="login-button">Login</Link>
              </div>
            )}
          </div>
        </nav>
      </header>

      {isOpen && currentUser && (
        <div 
          className="menu-overlay"
          onClick={(e) => e.target.classList.contains('menu-overlay') && setIsOpen(false)}
        >
          <div className="menu-content">
            <Link 
              to="/" 
              className={location.pathname === '/' ? 'active' : ''}
              onClick={() => handleLinkClick('/')}>
              Home
            </Link>
            {hasPermission('VIEW_ABOUT') && (
              <Link 
                to="/about" 
                className={location.pathname === '/about' ? 'active' : ''}
                onClick={() => handleLinkClick('/about')}>
                About
              </Link>
            )}
            {hasPermission('VIEW_DASHBOARD') && (
              <Link 
                to="/dashboard" 
                className={location.pathname === '/dashboard' ? 'active' : ''}
                onClick={() => handleLinkClick('/dashboard')}>
                Dashboard
              </Link>
            )}
            {hasPermission('VIEW_FORMS') && (
              <Link 
                to="/forms" 
                className={location.pathname.startsWith('/forms') ? 'active' : ''}
                onClick={() => handleLinkClick('/forms')}>
                Forms
              </Link>
            )}
            {/* Removed Active Forms link */}
            {hasPermission('MANAGE_USERS') && (
              <Link 
                to="/manage" 
                className={location.pathname.startsWith('/manage') ? 'active' : ''}
                onClick={() => handleLinkClick('/manage')}>
                Manage
              </Link>
            )}
            {hasPermission('VIEW_WASTE') && (
              <Link 
                to="/waste" 
                className={location.pathname === '/waste' ? 'active' : ''}
                onClick={() => handleLinkClick('/waste')}>
                Waste
              </Link>
            )}
            <div className="menu-footer">
              <span className="welcome-text">Welcome, {currentUser.email}</span>
              <button onClick={handleLogout} className="logout-button">
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;